import Domains from 'components/Filters/Accreditations/Domains'
import type { FilterValues } from 'hooks/filters'
import type { SelectValue } from 'shared/types'

interface AccreditationFiltersProps {
  values: FilterValues
  setValue: Function
}

export default function AccreditationFilters({ values, setValue }: AccreditationFiltersProps) {
  return (
    <div className="grid grid-cols-2 gap-y-4">
      <Domains
        value={values?.accreditationDomain || []}
        onChange={(vals: SelectValue[]) => setValue('accreditationDomain', vals)}
      />
    </div>
  )
}
